import React from 'react';
import {Container, Typography, Paper} from '@mui/material';

const Terms = () => {
    return (
        <Container component="main" maxWidth="md" sx={{mt: 4, mb: 4}}>
            <Typography variant="h4" gutterBottom>
                Terms of Service
            </Typography>
            <Typography variant="body1" paragraph>
                Welcome to EchoBud! We are thrilled to have you here. Before you begin using our services, please take
                some time to read our Terms of Service ("Terms") carefully.
            </Typography>
            <Typography variant="body1" paragraph>
                <strong>Acceptance of Terms</strong>
                <br/>
                By accessing and using EchoBud, you accept and agree to be bound by the terms and provision of this
                agreement. In addition, when using these particular services, you shall be subject to any posted
                guidelines or rules applicable to such services.
            </Typography>
            <Typography variant="body1" paragraph>
                <strong>Modification of Terms</strong>
                <br/>
                We reserve the right, at our discretion, to change, modify, add, or remove portions of these Terms at
                any time. Please check these Terms periodically for changes. Your continued use of EchoBud after the
                posting of changes will mean you accept and agree to the changes.
            </Typography>
            <Typography variant="body1" paragraph>
                <strong>User Responsibilities</strong>
                <br/>
                You are responsible for maintaining the confidentiality of your account and password and for restricting
                access to your computer, and you agree to accept responsibility for all activities that occur under your
                account or password.
            </Typography>
            <Typography variant="body1" paragraph>
                <strong>Privacy Policy</strong>
                <br/>
                Your privacy is very important to us. We designed our Privacy Policy to make important disclosures about
                how you can use EchoBud to share with others and how we collect and can use your content and
                information. We encourage you to read the Privacy Policy, and to use it to help you make informed
                decisions.
            </Typography>
            <Typography variant="body1" paragraph>
                <strong>Termination</strong>
                <br/>
                You agree that we may, under certain circumstances and without prior notice, immediately terminate your
                EchoBud account and access to the service. Cause for such termination shall include, but not be limited
                to, breaches or violations of the Terms or the Privacy Policy.
            </Typography>

        </Container>
    );
};

export default Terms;
